<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" query-api="dispatchQuery"
                                           $_em-custom-vuex-mixin_vo="dispatchVo"
                                           $_em-custom-vuex-mixin_filter="dispatchFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdPpOperationResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" edit-disable
                                      query-api="dispatchQuery"
                                      $_em-custom-vuex-mixin_vo="dispatchVo"
                                      $_em-custom-vuex-mixin_filter="dispatchFilter"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button type="add"
                                               custom-label="派工"
                                               :busy="dispatchLoading"
                                               custom-icon="fa fa-fw fa-lg fa-check"
                                               :disabled="$_notChecked"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openDispatchModal()">
                                    </em-button>
                                    <em-button type="save"
                                               custom-label="撤销派工"
                                               :busy="dispatchUndoLoading"
                                               custom-icon="fa fa-fw fa-lg fa-undo"
                                               :disabled="$_notChecked"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="handleDispatchUndo()"
                                               confirm-text="确定要撤销派工吗"
                                    >
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-print"
                                               :disabled="$_notChecked"
                                               custom-label="物料码打印"
                                               show-name
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="print()"
                                    >
                                    </em-button>
                                </template>
                                <!-- <template #customRowActions="{row}">
                                  <b-button-group>
                                    <em-button type="gotoGrandParent"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="gotoGrandParentLevel(row)">
                                    </em-button>
                                  </b-button-group>
                                </template> -->
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <re-b-modal id="dept-user-tree-modal"
                    ref="dispatchModal"
                    header="操作工选择"
                    no-auto-hide :ok-loading="dispatchLoading"
                    @ok="handleDispatchWorks()"
                    @hide="clearData">
            <dept-user-tree-m-t ref="deptUserTree" :custom-api="deptUserTreeAppendDispatchInfoApi"
                                @checkChanged="setDefaultWeight">
                <template #endOfRow="{row}">
                    <div v-if="dispatchCheckedIdSet.has(row.id) && row.id.startsWith(userPrefix)"
                         class="d-flex flex-row m-auto">
                        <div :class="userWeight[row.id] ? 'not_checked' : ''" class="font-weight-bold">0%
                        </div>
                        <b-form-checkbox v-model="userWeight[row.id]"
                                         class="ml-1" switch>
                        </b-form-checkbox>
                        <div :class="userWeight[row.id] ? '' : 'not_checked'" class="font-weight-bold">100%
                        </div>
                    </div>
                </template>
            </dept-user-tree-m-t>
        </re-b-modal>
    </div>
</template>
<script>
// Author YuJiaBei
// Date 2020-09-30 18:07:14

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emApiMixin from "@/mixin/em/common/api"
import commonViewsUtil from "@/utils/commonViewsUtil";
import DeptUserTreeMT from "@/components/em/EmBusiness/deptUserTree/DeptUserTreeMT.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    name: "sithMesPrdPpOperationDispatchListView",
    mixins: [emCommonListMixin, emCommonGotoMixin, emApiMixin, emTableCheckedMixin],
    components: {ReBModal, DeptUserTreeMT},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            deptUserTreeAppendDispatchInfoApi: `${this.$_emApiMixin_entityBaseApi("sithMesPrdPpOperation")}/deptUserTree`,
            userWeight: {},
            dispatchCheckedIdSet: new Set(),
            dispatchLoading: false,
            dispatchUndoLoading: false,
            userPrefix: "user_",
        }
    },
    computed: {
        modelName() {
            return "sithMesPrdPpOperation"
        },
        $_customVuexName() {
            return "dispatch";
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
        },
    },
    methods: {
        openDispatchModal() {
            this.$refs.dispatchModal.showModal();
        },
        handleDispatchWorks() {
            let userWeightList = [];
            let userNodes = this.$refs.deptUserTree.getUserNodes();
            for (let item of userNodes) {
                let userId = item.userId;
                if (userId) {
                    userWeightList.push({
                        userId: userId,
                        weight: this.userWeight[item.id] === false ? 0 : 100,
                    });
                }
            }
            let operationIds = this.selectIds;
            let url = `${this.$_emApiMixin_entityBaseApi("sithMesPrdOperationUser")}/dispatch`
            this.dispatchLoading = true;
            this.$_emApiMixin_post(url, {operationIds, userWeightList})
                .then(() => {
                    this.$refs.dispatchModal.hide();
                    commonViewsUtil.showSuccess(this, "派工成功")
                    this.$refs['emListFilter'].doQuery()
                }).finally(() => this.dispatchLoading = false);
        },
        handleDispatchUndo() {
            let url = `${this.$_emApiMixin_entityBaseApi("sithMesPrdOperationUser")}/dispatch/undo?ids=${this.selectIds}`
            this.dispatchUndoLoading = true;
            this.$_emApiMixin_post(url, {})
                .then(() => {
                    commonViewsUtil.showSuccess(this, "撤销派工成功")
                    this.$refs['emListFilter'].doQuery()
                }).finally(() => this.dispatchUndoLoading = false);
        },
        gotoGrandParentLevel(row) {
            this.$_emGotoMixin_gotoList("sithMesPrdPpHeader", row.prdPpHeaderId ? row.prdPpHeaderId : "")
        },
        print() {
            let url = `${this.entityBaseUrl}print?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    this.$router.push({
                        name: "sithMesInventoryItemPrint",
                        query: response.data,
                    });
                })
        },

        setDefaultWeight(list) {
            this.dispatchCheckedIdSet = new Set(list);
            for (let item of list) {
                if (!this.userWeight.hasOwnProperty(item)) {
                    this.$set(this.userWeight, item, true);
                }
            }
            this.$nextTick(() => this.$forceUpdate());
        },
        clearData() {
            this.userWeight = {};
            this.dispatchCheckedIdSet = new Set();
        },

    }
};
</script>

<style scoped>
.not_checked {
    color: #dfe2e6;
}
</style>
